.backToTop {
  position: fixed;
  bottom: 4em;
  right: 2em;
  background: #084b8a;
  color: white;
  border: none;
  border-radius: 4px; /* Slight rounding of corners */
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.3s ease;
  opacity: 0.9;
  padding: 12px;
}

.backToTop:hover {
  opacity: 1;
  transform: translateY(-5px);
  box-shadow: 0 12px 20px rgba(0, 0, 0, 0.2);
}

.backToTopIcon {
  width: 28px;
  height: 28px;
  color: white;
}
